import { render, staticRenderFns } from "./xiapu.vue?vue&type=template&id=408f13ce&scoped=true&"
import script from "./xiapu.vue?vue&type=script&lang=js&"
export * from "./xiapu.vue?vue&type=script&lang=js&"
import style0 from "./xiapu.vue?vue&type=style&index=0&id=408f13ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408f13ce",
  null
  
)

export default component.exports